module.exports = __webpack_public_path__ + "static/img/2ChinaBankCard.c8a8708d.png";